import { FormControlLabel, RadioGroup as MuiRadioGroup, Radio } from '@mui/material';
import React from 'react';

import { InputRenderer } from '../types';

import HiddenInput from './HiddenInput';

const RadioGroup = ({ inputProps, options, required }: InputRenderer) => {
  return (
    <>
      <MuiRadioGroup aria-labelledby={`${inputProps.name}-label`} {...inputProps}>
        {required && <HiddenInput inputProps={inputProps} required={required} />}
        {options?.map((option) => (
          <FormControlLabel control={<Radio />} key={option.key} label={option.label} value={option.key} />
        ))}
      </MuiRadioGroup>
    </>
  );
};

export default RadioGroup;
